// @core/api/endpoints/secret/get_pki_role.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  PkiRoleResponse,
} from '../../../types/secret';

const BASE_PATH = '/secret';

/**
 * Get PKI role
 * Returns a PKI role definition by name.
 */
export async function GetPkiRole(
  engine_id: string,
  role_name: string,
  options?: RequestOptions
): Promise<PkiRoleResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/engines/:engine_id/pki/roles/:role_name`;
  requestPath = requestPath.replace(':engine_id', encodeURIComponent(engine_id));
  requestPath = requestPath.replace(':role_name', encodeURIComponent(role_name));
  const requestOptions = options;
  return client.get<PkiRoleResponse>(requestPath, { ...requestOptions });
}
